export default {
  namespaced: true,
  state: {
    pathName: '',
    breadcrumbsList: []
  },
  mutations: {
    setPathName(state, payload) {
      state.pathName = payload;
    },
    setBreadcrumbsList(state, payload) {
      state.breadcrumbsList = payload;
    },
    deletePaths(state) {
      if (state.breadcrumbsList.length > 1) {
        state.pathName = '';
        state.breadcrumbsList = state.breadcrumbsList[state.breadcrumbsList.length - 1].text = state.pathName;
      }
    },
    updateList(state) {
      state.breadcrumbsList = state.breadcrumbsList.map(br => {
        if (state.pathName && br.isChildRoute) {
          br = {...br, text: state.pathName};
        }
        return br;
      });
    }
  },
  actions: {
    async setPathName({commit}, payload) {
      await commit('setPathName', payload);
      await commit('updateList');
    },
    async setBreadcrumbsList({commit}, payload) {
      await commit('setBreadcrumbsList', payload);
    },
    async deletePaths({commit}) {
      await commit('deletePaths');
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/location.js